export const breakpoints = {
    xs: '375px',
    figmaMobile: '428px', //reference for mobile
    sm: '480px',
    md: '768px',
    lg: '1024px',
    xl: '1200px',
    xxl: '1440px',
};